module.exports = __webpack_public_path__ + "img/street-view.514657df.svg";